export default __webpack_public_path__ + "static/pbs-wht-a2e00207eed7f76f68c482b8597f00dd.png";